"use strict";

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.is-array");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsbyBackgroundImage = _interopRequireDefault(require("gatsby-background-image"));

var LatticeBackgroundImage = function LatticeBackgroundImage(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? "" : _ref$tag,
      bgImageData = _ref.bgImageData,
      style = _ref.style;
  var outerGridClasses = [];

  if (className) {
    outerGridClasses = outerGridClasses.concat(Array.isArray(className) ? className : className.split(" "));
  }

  return _react["default"].createElement(_gatsbyBackgroundImage["default"], {
    Tag: tag,
    className: outerGridClasses.join(" "),
    fluid: bgImageData,
    style: style
  }, children);
};

LatticeBackgroundImage.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  tag: _propTypes["default"].string,
  bgImageData: _propTypes["default"].oneOfType([_propTypes["default"].shape({
    src: _propTypes["default"].string.isRequired
  }), _propTypes["default"].arrayOf(_propTypes["default"].shape({
    src: _propTypes["default"].string.isRequired
  }))]).isRequired,
  style: _propTypes["default"].objectOf(_propTypes["default"].string)
};
LatticeBackgroundImage.defaultProps = {
  children: null,
  className: "",
  tag: "div",
  style: {}
};
var _default = LatticeBackgroundImage;
exports["default"] = _default;